<template>
  <page layout="tabbed" :loading="isLoading">
    <page-header-new :title="$t('CampaignsPage_Title')">
      <template slot="actions">
        <el-button
          type="primary"
          plain
          @click="stopAllCampaigns"
          v-if="$can('updateProjectItem')"
          :disabled="!canStopAllCampaigns || isLoading"
        >
          <icon
            glyph="stop"
            size="13"
            style="margin-right: 5px; vertical-align: top"
          />
          {{ $t('CampaignsPage_Button_StopAllCampaigns') }}
        </el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="createCampaign"
          v-if="$can('createProjectItem')"
        >
          {{ $t('CampaignsPage_Button_CreateCampaign') }}
        </el-button>
      </template>
    </page-header-new>
    <page-tabs :tabs="tabs"></page-tabs>
  </page>
</template>

<script>
import Page from '@/common/components/page/Page'
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import PageTabs from '@/common/components/page/PageTabs'
import { EventBus } from '@/core/EventBus'
import Icon from '@/common/components/Icon'
import RestApi from '@/core/services/RestApi'

export default {
  name: 'CampaignsPage',
  components: { PageTabs, PageHeaderNew, Page, Icon },
  data() {
    return {
      stopAllTaskId: -1,
      taskPingInterval: null,
      isLoading: false,
      canStopAllCampaigns: false
    }
  },
  mounted() {
    EventBus.$on('setLoading', loading => {
      this.isLoading = loading
    })

    EventBus.$on('refreshStopAll', () => {
      this.toggleStopAllButton()
    })

    this.toggleStopAllButton()
  },
  methods: {
    createCampaign() {
      this.$router.push(projectRoute({ name: 'CreateCampaign' }))
    },
    stopAllEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: `campaigns/stop-all`
      })
    },
    checkIsLiveEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: `campaigns/check-live`
      })
    },
    taskStatusEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `task/records/${this.stopAllTaskId}`
      })
    },
    stopAllCampaigns() {
      this.$msgbox({
        title: this.$t('CampaignsPage_Dialog_StopAllTitle'),
        message: this.$t('CampaignsPage_Dialog_StopAllPrompt'),
        customClass: 'msgbox-danger',
        confirmButtonClass: 'el-button--danger',
        cancelButtonClass: 'el-button--danger-outline',
        showCancelButton: true,
        confirmButtonText: this.$t('CampaignsPage_Button_StopAllCampaigns'),
        cancelButtonText: this.$t('RestList_StopCancelButton'),
        dangerouslyUseHTMLString: true,
        center: true
      })
        .then(() => {
          this.$msgbox({
            title: this.$t('CampaignsPage_Dialog_StopAllTitle_Confirm'),
            message: this.$t('CampaignsPage_Dialog_StopAllPrompt_Confirm'),
            customClass: 'msgbox-danger',
            confirmButtonClass: 'el-button--danger',
            cancelButtonClass: 'el-button--danger-outline',
            showCancelButton: true,
            confirmButtonText: this.$t('CampaignsPage_Button_StopAllCampaigns'),
            cancelButtonText: this.$t('RestList_StopCancelButton'),
            dangerouslyUseHTMLString: true,
            center: true
          })
            .then(() => {
              EventBus.$emit('setLoading', true)
              RestApi(this.stopAllEndpoint())
                .then(({ data }) => {
                  this.stopAllTaskId = data.task_id || -1
                })
                .catch(error => {
                  EventBus.$emit('setLoading', false)
                  this.$message({
                    message: error.message,
                    type: 'error'
                  })
                })
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    pingStopAllEndpoint() {
      this.taskPingInterval = setInterval(() => {
        RestApi(this.taskStatusEndpoint())
          .then(({ data }) => {
            switch (data.status) {
              case 0: // TASK_STATUS_NEW
              case 1: // TASK_STATUS_IN_PROGRESS
                break
              default:
                this.toggleStopAllButton()
                this.stopAllTaskId = -1
                var message = data.result
                  ? this.$t('CampaignsPage_Message_StopAllSuccessMessage')
                  : this.$t('Error_500Message')
                if (data.errors) {
                  message = data.errors
                }

                this.$message({
                  message,
                  type: !data.errors && data.result ? 'success' : 'error'
                })
                EventBus.$emit('refreshList')
                EventBus.$emit('setLoading', false)
                break
            }
          })
          .catch(error => {
            this.stopAllTaskId = -1
            EventBus.$emit('setLoading', false)
            this.$message({
              message: error.message,
              type: 'error'
            })
          })
      }, 500)
    },
    toggleStopAllButton() {
      RestApi(this.checkIsLiveEndpoint())
        .then(({ data }) => {
          this.canStopAllCampaigns = data
        })
        .catch(_error => {
          this.canStopAllCampaigns = false
        })
    }
  },
  watch: {
    stopAllTaskId: {
      handler: function(value) {
        if (value === -1) {
          if (this.taskPingInterval) {
            clearInterval(this.taskPingInterval)
            this.taskPingInterval = null
          }
          return
        }

        if (this.taskPingInterval) {
          return
        }

        this.pingStopAllEndpoint()
      }
    }
  },
  computed: {
    tabs() {
      return [
        {
          title: this.$t('CampaignsPage_Tab_All'),
          route: projectRoute({ name: 'AllCampaignsTab' })
        },
        {
          title: this.$t('CampaignsPage_Tab_Scheduled'),
          route: projectRoute({ name: 'ScheduledCampaignsTab' })
        },
        {
          title: this.$t('CampaignsPage_Tab_Live'),
          route: projectRoute({ name: 'LiveCampaignsTab' })
        },
        {
          title: this.$t('CampaignsPage_Tab_Past'),
          route: projectRoute({ name: 'PastCampaignsTab' })
        },
        {
          title: this.$t('CampaignsPage_Tab_Drafts'),
          route: projectRoute({ name: 'DraftCampaignsTab' })
        }
      ]
    }
  }
}
</script>

<style>
.msgbox-danger .el-button.el-button--default.el-button--danger {
  color: #fff;
  background-color: #f56c6c;
  border-color: #f56c6c;
}

.msgbox-danger .el-button.el-button--default.el-button--danger-outline {
  color: #f56c6c;
  background-color: #fff;
  border-color: #f56c6c;
}

.msgbox-danger p.red {
  color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaigns/pages/CampaignsPage.vue